module.exports = __webpack_public_path__ + "img/contribute_4.7eb3fdfc.png";